import React, { useId, useState } from "react";
import { ChevronDown } from "lucide-react";

// Accessible FAQ list. Every answer is present in the DOM at load (crawlers and AI
// fetchers see the text without interaction); the collapse is CSS only, no display:none.
export default function FaqList({ items, testId }) {
  const [open, setOpen] = useState(null);
  const base = useId().replace(/:/g, "");

  return (
    <div className="border-t border-umber/20">
      {items.map((item, i) => {
        const isOpen = open === i;
        const panelId = `${base}-panel-${i}`;
        const buttonId = `${base}-button-${i}`;
        return (
          <div
            key={item.q}
            data-testid={testId ? testId(i) : undefined}
            className="border-b border-umber/20"
          >
            <h3>
              <button
                type="button"
                id={buttonId}
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpen(isOpen ? null : i)}
                className="w-full flex items-start justify-between gap-6 text-left py-7 group focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-forest focus-visible:ring-offset-4 focus-visible:ring-offset-paper"
              >
                <span className="font-display text-xl md:text-2xl text-umber group-hover:text-forest transition-colors">
                  {item.q}
                </span>
                <ChevronDown
                  size={20}
                  strokeWidth={1.6}
                  aria-hidden="true"
                  className={`mt-1 shrink-0 text-umber/50 transition-transform duration-200 ${
                    isOpen ? "rotate-180 text-forest" : ""
                  }`}
                />
              </button>
            </h3>
            <div
              id={panelId}
              role="region"
              aria-labelledby={buttonId}
              className="grid transition-[grid-template-rows,opacity] duration-200 ease-out"
              style={{
                gridTemplateRows: isOpen ? "1fr" : "0fr",
                opacity: isOpen ? 1 : 0,
              }}
            >
              <div className="overflow-hidden">
                <p className="text-umber/80 leading-relaxed text-base md:text-lg pb-7 pr-6 max-w-3xl">
                  {item.a}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
